import { AlertTriangle, CheckCheck, CircleX } from "lucide-react";

const TroubleshootingInfo = ({ warnings, errors }) => {
  return (
    <div className="flex items-center">
      {errors && errors > 0 ? (
        <>
          <CircleX className="text-red-500 w-4 h-4" />
          <span className="ml-2 text-sm text-white">
            {`${errors} error${errors > 1 ? "s" : ""}`}
          </span>
        </>
      ) : warnings && warnings > 0 ? (
        <>
          <AlertTriangle className="text-yellow-500 w-4 h-4" />
          <span className="ml-2 text-sm text-white">
            {`${warnings} warning${warnings > 1 ? "s" : ""}`}
          </span>
        </>
      ) : (
        <>
          <CheckCheck className="text-green-500 w-4 h-4 mr-2" />
          <span className="text-sm text-white">No errors</span>
        </>
      )}
    </div>
  );
};
export default TroubleshootingInfo;
